<template>
  <div class="flex flex-1">
    <ImagePicker
      :size="48"
      :icon-size="20"
      :border-color="'rgba(255, 255, 255, 0.2)'"
      :img="imageSrc"
      :actions="[]"
      class="w-full flex-shrink-0"
      @delete="() => $emit('delete')"
      @change="(image:string)=>$emit( 'upload',image,)"
    />

    <!-- 空状态 -->
    <template v-if="item.emptyImageType == 'empty'">
      <div class="opacity-70 text-sm flex justify-center items-center ml-3">
        <!-- 是否为空状态默认值 -->
        <span class="">
          <a-tooltip :title="'未获取数据时显示“--”，请上传“-”'">
            <icon icon="help.svg" :width="14" :height="14" fill="none" />
          </a-tooltip>
        </span>
        <span>空状态</span>
      </div>
    </template>
    <!-- 输入框 -->
    <div v-else class="_grid ml-2 w-full">
      <div class="flex items-center">
        <a-input-number
          :value="values[0]"
          class="border-r-0"
          :controls="false"
          :precision="0"
          :min="0"
          :max="100"
          @change="(v:number) => onInputChange(v, 'start')"
        >
          <template #addonAfter>
            <span class="">%</span>
          </template>
        </a-input-number>
      </div>
      <div class="flex items-center justify-center">
        <span>至</span>
      </div>
      <div class="flex items-center">
        <a-input-number
          :value="values[1]"
          :controls="false"
          class="border-r-0"
          :min="0"
          :max="100"
          :precision="0"
          @change="(v:number) => onInputChange(v, 'end')"
        >
          <template #addonAfter>
            <span class="">%</span>
          </template>
        </a-input-number>
      </div>
      <div class="flex items-center pl-2 justify-between w-full">
        <span v-if="item.index != 0" @click="() => onDelete()">
          <a-tooltip title="删除">
            <icon :icon="'subtract.svg'" :click="14" :height="14" />
          </a-tooltip>
        </span>

        <span v-if="item.index == 0" @click="onAdd">
          <a-tooltip title="添加">
            <icon :icon="'add.svg'" :width="14" :height="14" />
          </a-tooltip>
        </span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ImageArrayIndex } from '@/hooks/use-image-array';
import { Shape } from '@/services/shape';
import { PropType, computed } from 'vue';
import { Modal } from 'ant-design-vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  item: {
    type: Object as PropType<ImageArrayIndex>,
    required: true
  },
  imageSrc: {
    type: String,
    default: ''
  }
});

const emits = defineEmits<{
  (event: 'delete'): void;
  (event: 'upload', image: string): void;
}>();

const values = computed(() => {
  return props.shape.attrs.sourceProgressCustom?.[props.item.index] ?? [];
});

// 删除或添加操作
const onDelete = () => {
  const shape = props.shape;
  const index = props.item.index;
  const sourceProgressCustom = shape.attrs.sourceProgressCustom ?? [];
  const _value = sourceProgressCustom.filter((_, i) => i != index);
  shape.setAttrs({
    sourceProgressCustom: _value
  });
  // 删除图片
  emits('delete');
};
const onAdd = () => {
  const shape = props.shape;
  const sourceProgressCustom = [...(shape.attrs.sourceProgressCustom ?? [])];
  if (sourceProgressCustom.length >= 30) {
    Modal.warning({
      title: '提示',
      content: '最多只允许添加30项！',
      okText: '知道了'
    });
    return;
  }
  const last = sourceProgressCustom[sourceProgressCustom.length - 1];
  // 添加一个和最好一个一样的内容
  if (last) sourceProgressCustom.push([Math.min(100, last[1] + 1), 100]);

  shape.setAttrs({
    sourceProgressCustom: sourceProgressCustom
  });
};

const onInputChange = (val: number, type: 'start' | 'end') => {
  if (val == null || val == undefined) return;
  const shape = props.shape;
  const index = props.item.index;
  const sourceProgressCustom = [...(shape.attrs.sourceProgressCustom ?? [])];
  const pre = sourceProgressCustom[index - 1];
  const item = sourceProgressCustom[index];
  const next = sourceProgressCustom[index + 1];
  if (type == 'start') {
    item[0] = val;
    if (pre) pre[1] = val - 1;
  } else {
    item[1] = val;
    if (next) next[0] = val + 1;
  }
  shape.setAttrs({
    sourceProgressCustom: sourceProgressCustom
  });
};
</script>
<style scoped lang="less">
._grid {
  display: grid;
  grid-template-columns: 75px 25px 75px 1fr;
}
:deep(.ant-input-number-group-addon) {
  padding: 4px;
  font-size: 0.875rem;
}
</style>
